import React from 'react';
import HeartBubble from './HeartBubble';

const About = () => {
  return (
    <section id="about" className="relative bg-charcoal py-20 md:py-28 overflow-hidden">
      <HeartBubble size={130} className="top-10 left-[6%] float-anim hidden md:block" rotate={-10} />

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <h2 className="section-title text-center mb-16">Über Uns</h2>

        <div className="space-y-14">
          <div className="border-l-4 border-yellow pl-6 md:pl-8">
            <h3 className="font-display text-yellow text-3xl md:text-4xl mb-4">
              Unsere Mission
            </h3>
            <p className="text-zinc-100 font-semibold text-lg mb-4">
              Dein Erfolg in den sozialen Medien ist unsere Leidenschaft!
            </p>
            <p className="text-zinc-300 leading-relaxed text-base mb-4">
              Unsere Mission ist es, kleinen und mittelständischen Unternehmen (KMU) dabei zu helfen, ihre Marke durch professionelles Social Media Marketing sichtbar zu machen. Wir übernehmen die komplette Betreuung deiner Social Media Kanäle, erstellen zielgruppenorientierte Inhalte und entwickeln maßgeschneiderte Strategien, die zu mehr Reichweite, Engagement und Umsatz führen.
            </p>
            <p className="text-zinc-300 leading-relaxed text-base">
              Mit unserem 360°-Service sorgen wir dafür, dass du dich voll und ganz auf dein Kerngeschäft konzentrieren kannst – während wir deine digitale Präsenz stärken. Unser erfahrenes Team nutzt datenbasierte Analysen, kreative Inhalte und innovative Werbestrategien, um messbare Ergebnisse zu erzielen.
            </p>
          </div>

          <div className="border-l-4 border-yellow pl-6 md:pl-8">
            <h3 className="font-display text-yellow text-3xl md:text-4xl mb-4">
              Unsere Vision
            </h3>
            <p className="text-zinc-100 font-semibold text-lg mb-4">
              Unsere Vision ist es, deine Marke in den sozialen Medien strahlen zu lassen.
            </p>
            <p className="text-zinc-300 leading-relaxed text-base mb-4">
              Die Zukunft des digitalen Marketings aktiv mitgestalten. Unsere Vision ist es, eine der führenden Social Media Agenturen zu werden. Wir möchten innovative Trends frühzeitig erkennen und für unsere Kunden umsetzen, um ihnen einen nachhaltigen Wettbewerbsvorteil zu verschaffen.
            </p>
            <p className="text-zinc-300 leading-relaxed text-base">
              Durch eine enge Zusammenarbeit und eine transparente Kommunikation schaffen wir Vertrauen und langfristige Partnerschaften. Unser Ziel ist es, Unternehmen nicht nur auf Social Media sichtbar zu machen, sondern sie als starke Marken zu etablieren, die Kunden begeistern und binden.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
